<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12" lg="12" class="pb-0 pt-0">
				<v-card flat>
					<v-card-text class="pb-0 pt-2">
						<v-row>
							<v-col class="d-flex justify-start pa-0 pl-2">
								<v-btn color="primary" @click="addClick">
									<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.add') }}
								</v-btn>
							</v-col>
							<v-col class="d-flex justify-center pb-0 pt-0">
								<v-card-title class="text-center pa-2 pb-2 pt-0">
									{{ $t('modules.teachers') }}</v-card-title
								>
							</v-col>
							<v-col></v-col>
						</v-row>
						<v-row>
							<v-col class="pb-0 pt-0">
								<TheTable
									:additional-filters="teachersTable.additionalFilters"
									:default-sort="teachersTable.defaultSort"
									:excel="true"
									:fields="teachersTable.headers"
									:header-selection-key="'teachers-headers'"
									:height="teachersTable.height"
									:total-records="teachersTable.total"
									:filter-save-key="'teachers-filters'"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in teachersTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editClick(props.item.id, true)"
									>
										<td
											v-if="teachersTable.selectedHeaders.includes('id')"
											@click="editClick(item.id, false)"
										>
											{{ item.id }}
										</td>
										<td
											v-if="teachersTable.selectedHeaders.includes('first_name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.first_name }}</b>
										</td>
										<td
											v-if="teachersTable.selectedHeaders.includes('last_name')"
											@click="editClick(item.id, false)"
										>
											<b>{{ item.last_name }}</b>
										</td>
										<td
											v-if="teachersTable.selectedHeaders.includes('title')"
											@click="editClick(item.id, false)"
										>
											{{ item.title }}
										</td>
										<td
											v-if="teachersTable.selectedHeaders.includes('email')"
											@click="editClick(item.id, false)"
										>
											{{ item.email }}
										</td>
										<td
											v-if="teachersTable.selectedHeaders.includes('phone')"
											@click="editClick(item.id, false)"
										>
											{{ item.phone }}
										</td>
										<td
											v-if="teachersTable.selectedHeaders.includes('city')"
											@click="editClick(item.id, false)"
										>
											{{ item.city }}
										</td>
										<td
											v-if="teachersTable.selectedHeaders.includes('active')"
											@click="editClick(item.id, false)"
										>
											<v-icon v-if="item.active" small>fa-check</v-icon>
										</td>
										<td>
											<v-tooltip bottom>
												<template v-slot:activator="{ on, attrs }">
													<v-btn
														icon
														small
														v-bind="attrs"
														@click="editClick(item.id, true)"
														v-on="on"
													>
														<v-icon small>fa-external-link-alt</v-icon>
													</v-btn>
												</template>
												<span>{{ $t('tooltips.openInNewTab') }}</span>
											</v-tooltip>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import TheTable from '../../trinkets/TheTable';

export default {
	name: 'Teachers',
	components: { TheTable },
	data: function () {
		return {
			teachersTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.id'), value: 'id', type: 'string', width: '60px', allowFilter: true },
					{ text: this.$t('fields.firstName'), value: 'first_name', type: 'string', allowFilter: true },
					{ text: this.$t('fields.lastName'), value: 'last_name', type: 'string', allowFilter: true },
					{ text: this.$t('fields.title'), value: 'title', type: 'string', allowFilter: true },
					{ text: this.$t('fields.email'), value: 'email', type: 'string', allowFilter: true },
					{ text: this.$t('fields.phone'), value: 'phone', type: 'string', allowFilter: true },
					{ text: this.$t('fields.city'), value: 'city', type: 'string', allowFilter: true },
					{
						text: this.$t('fields.active'),
						value: 'active',
						type: 'boolean',
						width: '100px',
						allowFilter: false,
					},
					{ text: '', value: 'actions', type: '', sortable: false, width: '100px', allowFilter: false },
				],
				additionalFilters: [],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'last_name',
					descending: true,
				},
			},
		};
	},
	methods: {
		addClick() {
			this.$router.push('/teachers/0');
		},
		editClick(id, newTab = false) {
			if (!newTab) {
				this.$router.push('/teachers/' + id);
			} else {
				let routeData = this.$router.resolve('/teachers/' + id);
				window.open(routeData.href, '_blank');
			}
		},
		selectHeaders(headers) {
			this.teachersTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.teachersTable.lastRequest = request;
			let vm = this;
			this.$APICall(
				'get',
				'teachers',
				request,
				(data, success) => {
					if (success) {
						vm.teachersTable.items = data.items;
						vm.teachersTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		excelExport() {
			let excelRequest = JSON.parse(JSON.stringify(this.teachersTable.lastRequest));
			excelRequest.pagination.itemsPerPage = 999999999;
			excelRequest.pagination.page = 1;

			let vm = this;
			this.$APICall(
				'get',
				'teachers',
				excelRequest,
				(data, success) => {
					if (success) {
						vm.$APICall('post', 'excel/teachers', data.items, (data, success) => {
							window.open(data.link);
						});
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		resolveWindowResize() {
			this.teachersTable.height = window.innerHeight - 215 + 'px';
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.teachers'), href: '/#/teachers', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style scoped></style>
